// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"TL-z","hovered":"UL-z","hoverImage":"VL-z","mainImage":"WL-z","imageNoBackground":"XL-z","fullSizeImage":"YL-z"};